import _ from 'lodash';
import { productService } from '../services/products.service';

const state = {
  all: []
};

const actions = {
  async getAll({ dispatch, commit }) {
    try {
      const products = await productService.getProducts();
      commit('getProductsSuccess', products);
    }
    catch (error) {
      throw error;
    }
  }
};

const getters = {
  getProduct: state => productId => {
    return _.find(state.all, p => p.id === productId);
  }
};

const mutations = {
  getProductsSuccess(state, products) {
    state.all = products;
  }
};

export const products = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
